// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReembolsoRouteImport } from './routes/reembolso'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CadastroRouteImport } from './routes/cadastro'
import { Route as AvisoLegalRouteImport } from './routes/aviso-legal'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckoutSucessoRouteImport } from './routes/checkout.sucesso'
import { Route as AuthenticatedMembrosRouteImport } from './routes/_authenticated/membros'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedMembrosIndexRouteImport } from './routes/_authenticated/membros.index'
import { Route as AuthenticatedMembrosValidacaoRouteImport } from './routes/_authenticated/membros.validacao'
import { Route as AuthenticatedMembrosPrimeirosClientesRouteImport } from './routes/_authenticated/membros.primeiros-clientes'
import { Route as AuthenticatedMembrosPlano30DiasRouteImport } from './routes/_authenticated/membros.plano-30-dias'
import { Route as AuthenticatedMembrosPerfilRouteImport } from './routes/_authenticated/membros.perfil'
import { Route as AuthenticatedMembrosFavoritosRouteImport } from './routes/_authenticated/membros.favoritos'
import { Route as AuthenticatedMembrosDownloadsRouteImport } from './routes/_authenticated/membros.downloads'
import { Route as AuthenticatedMembrosDiagnosticoRouteImport } from './routes/_authenticated/membros.diagnostico'
import { Route as AuthenticatedMembrosCalculadora10kRouteImport } from './routes/_authenticated/membros.calculadora-10k'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminUsuariosRouteImport } from './routes/_authenticated/admin.usuarios'
import { Route as AuthenticatedAdminReceitaRouteImport } from './routes/_authenticated/admin.receita'
import { Route as AuthenticatedAdminProdutosRouteImport } from './routes/_authenticated/admin.produtos'
import { Route as AuthenticatedAdminPedidosRouteImport } from './routes/_authenticated/admin.pedidos'
import { Route as AuthenticatedAdminNegociosRouteImport } from './routes/_authenticated/admin.negocios'
import { Route as AuthenticatedAdminLogsRouteImport } from './routes/_authenticated/admin.logs'
import { Route as AuthenticatedAdminIntegracoesRouteImport } from './routes/_authenticated/admin.integracoes'
import { Route as AuthenticatedAdminInsightsRouteImport } from './routes/_authenticated/admin.insights'
import { Route as AuthenticatedAdminIaRouteImport } from './routes/_authenticated/admin.ia'
import { Route as AuthenticatedAdminHomologacaoRouteImport } from './routes/_authenticated/admin.homologacao'
import { Route as AuthenticatedAdminHealthRouteImport } from './routes/_authenticated/admin.health'
import { Route as AuthenticatedAdminFlagsRouteImport } from './routes/_authenticated/admin.flags'
import { Route as AuthenticatedAdminFeedbackRouteImport } from './routes/_authenticated/admin.feedback'
import { Route as AuthenticatedAdminExperimentsRouteImport } from './routes/_authenticated/admin.experiments'
import { Route as AuthenticatedAdminEntregaveisRouteImport } from './routes/_authenticated/admin.entregaveis'
import { Route as AuthenticatedAdminDownloadsRouteImport } from './routes/_authenticated/admin.downloads'
import { Route as AuthenticatedAdminCuponsRouteImport } from './routes/_authenticated/admin.cupons'
import { Route as AuthenticatedAdminConteudosRouteImport } from './routes/_authenticated/admin.conteudos'
import { Route as AuthenticatedAdminConfiguracoesRouteImport } from './routes/_authenticated/admin.configuracoes'
import { Route as AuthenticatedAdminCategoriasRouteImport } from './routes/_authenticated/admin.categorias'
import { Route as AuthenticatedAdminAssinaturasRouteImport } from './routes/_authenticated/admin.assinaturas'
import { Route as AuthenticatedAdminAnalyticsRouteImport } from './routes/_authenticated/admin.analytics'
import { Route as AuthenticatedMembrosNegociosIndexRouteImport } from './routes/_authenticated/membros.negocios.index'
import { Route as AuthenticatedMembrosMeuProjetoIndexRouteImport } from './routes/_authenticated/membros.meu-projeto.index'
import { Route as AuthenticatedMembrosMeuNegocioIndexRouteImport } from './routes/_authenticated/membros.meu-negocio.index'
import { Route as AuthenticatedMembrosEntregaveisIndexRouteImport } from './routes/_authenticated/membros.entregaveis.index'
import { Route as AuthenticatedMembrosNegociosSlugRouteImport } from './routes/_authenticated/membros.negocios.$slug'
import { Route as AuthenticatedMembrosMeuProjetoMateriaisRouteImport } from './routes/_authenticated/membros.meu-projeto.materiais'
import { Route as AuthenticatedMembrosMeuNegocioPlanoRouteImport } from './routes/_authenticated/membros.meu-negocio.plano'
import { Route as AuthenticatedMembrosMeuNegocioPendenciasRouteImport } from './routes/_authenticated/membros.meu-negocio.pendencias'
import { Route as AuthenticatedMembrosEntregaveisKeyRouteImport } from './routes/_authenticated/membros.entregaveis.$key'
import { Route as AuthenticatedAdminBetaIndexRouteImport } from './routes/_authenticated/admin.beta.index'
import { Route as AuthenticatedAdminBetaUserIdRouteImport } from './routes/_authenticated/admin.beta.$userId'
import { Route as AuthenticatedAdminIaHomologacaoRouteImport } from './routes/_authenticated/admin.ia.homologacao'
import { Route as AuthenticatedMembrosMeuProjetoProjetoIdRouteImport } from './routes/_authenticated/membros.meu-projeto.projeto.$id'
import { Route as AuthenticatedMembrosMeuProjetoMissaoIdRouteImport } from './routes/_authenticated/membros.meu-projeto.missao.$id'
import { Route as AuthenticatedMembrosMeuNegocioSecaoSectionRouteImport } from './routes/_authenticated/membros.meu-negocio.secao.$section'
import { Route as AuthenticatedAdminBetaCiclosIndexRouteImport } from './routes/_authenticated/admin.beta.ciclos.index'
import { Route as AuthenticatedAdminBetaCiclosCycleIdRouteImport } from './routes/_authenticated/admin.beta.ciclos.$cycleId'
import { Route as AuthenticatedAdminConteudosJornadasIndexRouteImport } from './routes/_authenticated/admin.conteudos.jornadas.index'
import { Route as AuthenticatedAdminConteudosJornadasTemplateIdRouteImport } from './routes/_authenticated/admin.conteudos.jornadas.$templateId'
import { Route as AuthenticatedAdminConteudosJornadasPreviewMissionIdRouteImport } from './routes/_authenticated/admin.conteudos.jornadas.preview.$missionId'

const TermosRoute = TermosRouteImport.update({
            id: '/termos',path: '/termos',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ReembolsoRoute = ReembolsoRouteImport.update({
            id: '/reembolso',path: '/reembolso',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const NoAccessRoute = NoAccessRouteImport.update({
            id: '/no-access',path: '/no-access',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const CadastroRoute = CadastroRouteImport.update({
            id: '/cadastro',path: '/cadastro',getParentRoute: () => rootRouteImport
          })
const AvisoLegalRoute = AvisoLegalRouteImport.update({
            id: '/aviso-legal',path: '/aviso-legal',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CheckoutSucessoRoute = CheckoutSucessoRouteImport.update({
            id: '/sucesso',path: '/sucesso',getParentRoute: () => CheckoutRoute
          })
const AuthenticatedMembrosRoute = AuthenticatedMembrosRouteImport.update({
            id: '/membros',path: '/membros',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMembrosIndexRoute = AuthenticatedMembrosIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosValidacaoRoute = AuthenticatedMembrosValidacaoRouteImport.update({
            id: '/validacao',path: '/validacao',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosPrimeirosClientesRoute = AuthenticatedMembrosPrimeirosClientesRouteImport.update({
            id: '/primeiros-clientes',path: '/primeiros-clientes',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosPlano30DiasRoute = AuthenticatedMembrosPlano30DiasRouteImport.update({
            id: '/plano-30-dias',path: '/plano-30-dias',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosPerfilRoute = AuthenticatedMembrosPerfilRouteImport.update({
            id: '/perfil',path: '/perfil',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosFavoritosRoute = AuthenticatedMembrosFavoritosRouteImport.update({
            id: '/favoritos',path: '/favoritos',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosDownloadsRoute = AuthenticatedMembrosDownloadsRouteImport.update({
            id: '/downloads',path: '/downloads',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosDiagnosticoRoute = AuthenticatedMembrosDiagnosticoRouteImport.update({
            id: '/diagnostico',path: '/diagnostico',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosCalculadora10kRoute = AuthenticatedMembrosCalculadora10kRouteImport.update({
            id: '/calculadora-10k',path: '/calculadora-10k',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminUsuariosRoute = AuthenticatedAdminUsuariosRouteImport.update({
            id: '/usuarios',path: '/usuarios',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminReceitaRoute = AuthenticatedAdminReceitaRouteImport.update({
            id: '/receita',path: '/receita',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminProdutosRoute = AuthenticatedAdminProdutosRouteImport.update({
            id: '/produtos',path: '/produtos',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPedidosRoute = AuthenticatedAdminPedidosRouteImport.update({
            id: '/pedidos',path: '/pedidos',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminNegociosRoute = AuthenticatedAdminNegociosRouteImport.update({
            id: '/negocios',path: '/negocios',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLogsRoute = AuthenticatedAdminLogsRouteImport.update({
            id: '/logs',path: '/logs',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminIntegracoesRoute = AuthenticatedAdminIntegracoesRouteImport.update({
            id: '/integracoes',path: '/integracoes',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminInsightsRoute = AuthenticatedAdminInsightsRouteImport.update({
            id: '/insights',path: '/insights',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminIaRoute = AuthenticatedAdminIaRouteImport.update({
            id: '/ia',path: '/ia',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminHomologacaoRoute = AuthenticatedAdminHomologacaoRouteImport.update({
            id: '/homologacao',path: '/homologacao',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminHealthRoute = AuthenticatedAdminHealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFlagsRoute = AuthenticatedAdminFlagsRouteImport.update({
            id: '/flags',path: '/flags',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFeedbackRoute = AuthenticatedAdminFeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminExperimentsRoute = AuthenticatedAdminExperimentsRouteImport.update({
            id: '/experiments',path: '/experiments',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEntregaveisRoute = AuthenticatedAdminEntregaveisRouteImport.update({
            id: '/entregaveis',path: '/entregaveis',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminDownloadsRoute = AuthenticatedAdminDownloadsRouteImport.update({
            id: '/downloads',path: '/downloads',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCuponsRoute = AuthenticatedAdminCuponsRouteImport.update({
            id: '/cupons',path: '/cupons',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminConteudosRoute = AuthenticatedAdminConteudosRouteImport.update({
            id: '/conteudos',path: '/conteudos',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminConfiguracoesRoute = AuthenticatedAdminConfiguracoesRouteImport.update({
            id: '/configuracoes',path: '/configuracoes',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCategoriasRoute = AuthenticatedAdminCategoriasRouteImport.update({
            id: '/categorias',path: '/categorias',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAssinaturasRoute = AuthenticatedAdminAssinaturasRouteImport.update({
            id: '/assinaturas',path: '/assinaturas',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAnalyticsRoute = AuthenticatedAdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedMembrosNegociosIndexRoute = AuthenticatedMembrosNegociosIndexRouteImport.update({
            id: '/negocios/',path: '/negocios/',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosMeuProjetoIndexRoute = AuthenticatedMembrosMeuProjetoIndexRouteImport.update({
            id: '/meu-projeto/',path: '/meu-projeto/',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosMeuNegocioIndexRoute = AuthenticatedMembrosMeuNegocioIndexRouteImport.update({
            id: '/meu-negocio/',path: '/meu-negocio/',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosEntregaveisIndexRoute = AuthenticatedMembrosEntregaveisIndexRouteImport.update({
            id: '/entregaveis/',path: '/entregaveis/',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosNegociosSlugRoute = AuthenticatedMembrosNegociosSlugRouteImport.update({
            id: '/negocios/$slug',path: '/negocios/$slug',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosMeuProjetoMateriaisRoute = AuthenticatedMembrosMeuProjetoMateriaisRouteImport.update({
            id: '/meu-projeto/materiais',path: '/meu-projeto/materiais',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosMeuNegocioPlanoRoute = AuthenticatedMembrosMeuNegocioPlanoRouteImport.update({
            id: '/meu-negocio/plano',path: '/meu-negocio/plano',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosMeuNegocioPendenciasRoute = AuthenticatedMembrosMeuNegocioPendenciasRouteImport.update({
            id: '/meu-negocio/pendencias',path: '/meu-negocio/pendencias',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosEntregaveisKeyRoute = AuthenticatedMembrosEntregaveisKeyRouteImport.update({
            id: '/entregaveis/$key',path: '/entregaveis/$key',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedAdminBetaIndexRoute = AuthenticatedAdminBetaIndexRouteImport.update({
            id: '/beta/',path: '/beta/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBetaUserIdRoute = AuthenticatedAdminBetaUserIdRouteImport.update({
            id: '/beta/$userId',path: '/beta/$userId',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminIaHomologacaoRoute = AuthenticatedAdminIaHomologacaoRouteImport.update({
            id: '/homologacao',path: '/homologacao',getParentRoute: () => AuthenticatedAdminIaRoute
          })
const AuthenticatedMembrosMeuProjetoProjetoIdRoute = AuthenticatedMembrosMeuProjetoProjetoIdRouteImport.update({
            id: '/meu-projeto/projeto/$id',path: '/meu-projeto/projeto/$id',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosMeuProjetoMissaoIdRoute = AuthenticatedMembrosMeuProjetoMissaoIdRouteImport.update({
            id: '/meu-projeto/missao/$id',path: '/meu-projeto/missao/$id',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedMembrosMeuNegocioSecaoSectionRoute = AuthenticatedMembrosMeuNegocioSecaoSectionRouteImport.update({
            id: '/meu-negocio/secao/$section',path: '/meu-negocio/secao/$section',getParentRoute: () => AuthenticatedMembrosRoute
          })
const AuthenticatedAdminBetaCiclosIndexRoute = AuthenticatedAdminBetaCiclosIndexRouteImport.update({
            id: '/beta/ciclos/',path: '/beta/ciclos/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBetaCiclosCycleIdRoute = AuthenticatedAdminBetaCiclosCycleIdRouteImport.update({
            id: '/beta/ciclos/$cycleId',path: '/beta/ciclos/$cycleId',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminConteudosJornadasIndexRoute = AuthenticatedAdminConteudosJornadasIndexRouteImport.update({
            id: '/jornadas/',path: '/jornadas/',getParentRoute: () => AuthenticatedAdminConteudosRoute
          })
const AuthenticatedAdminConteudosJornadasTemplateIdRoute = AuthenticatedAdminConteudosJornadasTemplateIdRouteImport.update({
            id: '/jornadas/$templateId',path: '/jornadas/$templateId',getParentRoute: () => AuthenticatedAdminConteudosRoute
          })
const AuthenticatedAdminConteudosJornadasPreviewMissionIdRoute = AuthenticatedAdminConteudosJornadasPreviewMissionIdRouteImport.update({
            id: '/jornadas/preview/$missionId',path: '/jornadas/preview/$missionId',getParentRoute: () => AuthenticatedAdminConteudosRoute
          })





const AuthenticatedAdminConteudosRouteChildren = {
  AuthenticatedAdminConteudosJornadasTemplateIdRoute: AuthenticatedAdminConteudosJornadasTemplateIdRoute,AuthenticatedAdminConteudosJornadasIndexRoute: AuthenticatedAdminConteudosJornadasIndexRoute,AuthenticatedAdminConteudosJornadasPreviewMissionIdRoute: AuthenticatedAdminConteudosJornadasPreviewMissionIdRoute
}

const AuthenticatedAdminConteudosRouteWithChildren = AuthenticatedAdminConteudosRoute._addFileChildren(AuthenticatedAdminConteudosRouteChildren)




const AuthenticatedAdminIaRouteChildren = {
  AuthenticatedAdminIaHomologacaoRoute: AuthenticatedAdminIaHomologacaoRoute
}

const AuthenticatedAdminIaRouteWithChildren = AuthenticatedAdminIaRoute._addFileChildren(AuthenticatedAdminIaRouteChildren)



const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAnalyticsRoute: AuthenticatedAdminAnalyticsRoute,AuthenticatedAdminAssinaturasRoute: AuthenticatedAdminAssinaturasRoute,AuthenticatedAdminCategoriasRoute: AuthenticatedAdminCategoriasRoute,AuthenticatedAdminConfiguracoesRoute: AuthenticatedAdminConfiguracoesRoute,AuthenticatedAdminConteudosRoute: AuthenticatedAdminConteudosRouteWithChildren,AuthenticatedAdminCuponsRoute: AuthenticatedAdminCuponsRoute,AuthenticatedAdminDownloadsRoute: AuthenticatedAdminDownloadsRoute,AuthenticatedAdminEntregaveisRoute: AuthenticatedAdminEntregaveisRoute,AuthenticatedAdminExperimentsRoute: AuthenticatedAdminExperimentsRoute,AuthenticatedAdminFeedbackRoute: AuthenticatedAdminFeedbackRoute,AuthenticatedAdminFlagsRoute: AuthenticatedAdminFlagsRoute,AuthenticatedAdminHealthRoute: AuthenticatedAdminHealthRoute,AuthenticatedAdminHomologacaoRoute: AuthenticatedAdminHomologacaoRoute,AuthenticatedAdminIaRoute: AuthenticatedAdminIaRouteWithChildren,AuthenticatedAdminInsightsRoute: AuthenticatedAdminInsightsRoute,AuthenticatedAdminIntegracoesRoute: AuthenticatedAdminIntegracoesRoute,AuthenticatedAdminLogsRoute: AuthenticatedAdminLogsRoute,AuthenticatedAdminNegociosRoute: AuthenticatedAdminNegociosRoute,AuthenticatedAdminPedidosRoute: AuthenticatedAdminPedidosRoute,AuthenticatedAdminProdutosRoute: AuthenticatedAdminProdutosRoute,AuthenticatedAdminReceitaRoute: AuthenticatedAdminReceitaRoute,AuthenticatedAdminUsuariosRoute: AuthenticatedAdminUsuariosRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminBetaUserIdRoute: AuthenticatedAdminBetaUserIdRoute,AuthenticatedAdminBetaIndexRoute: AuthenticatedAdminBetaIndexRoute,AuthenticatedAdminBetaCiclosCycleIdRoute: AuthenticatedAdminBetaCiclosCycleIdRoute,AuthenticatedAdminBetaCiclosIndexRoute: AuthenticatedAdminBetaCiclosIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)




const AuthenticatedMembrosRouteChildren = {
  AuthenticatedMembrosCalculadora10kRoute: AuthenticatedMembrosCalculadora10kRoute,AuthenticatedMembrosDiagnosticoRoute: AuthenticatedMembrosDiagnosticoRoute,AuthenticatedMembrosDownloadsRoute: AuthenticatedMembrosDownloadsRoute,AuthenticatedMembrosFavoritosRoute: AuthenticatedMembrosFavoritosRoute,AuthenticatedMembrosPerfilRoute: AuthenticatedMembrosPerfilRoute,AuthenticatedMembrosPlano30DiasRoute: AuthenticatedMembrosPlano30DiasRoute,AuthenticatedMembrosPrimeirosClientesRoute: AuthenticatedMembrosPrimeirosClientesRoute,AuthenticatedMembrosValidacaoRoute: AuthenticatedMembrosValidacaoRoute,AuthenticatedMembrosIndexRoute: AuthenticatedMembrosIndexRoute,AuthenticatedMembrosEntregaveisKeyRoute: AuthenticatedMembrosEntregaveisKeyRoute,AuthenticatedMembrosMeuNegocioPendenciasRoute: AuthenticatedMembrosMeuNegocioPendenciasRoute,AuthenticatedMembrosMeuNegocioPlanoRoute: AuthenticatedMembrosMeuNegocioPlanoRoute,AuthenticatedMembrosMeuProjetoMateriaisRoute: AuthenticatedMembrosMeuProjetoMateriaisRoute,AuthenticatedMembrosNegociosSlugRoute: AuthenticatedMembrosNegociosSlugRoute,AuthenticatedMembrosEntregaveisIndexRoute: AuthenticatedMembrosEntregaveisIndexRoute,AuthenticatedMembrosMeuNegocioIndexRoute: AuthenticatedMembrosMeuNegocioIndexRoute,AuthenticatedMembrosMeuProjetoIndexRoute: AuthenticatedMembrosMeuProjetoIndexRoute,AuthenticatedMembrosNegociosIndexRoute: AuthenticatedMembrosNegociosIndexRoute,AuthenticatedMembrosMeuNegocioSecaoSectionRoute: AuthenticatedMembrosMeuNegocioSecaoSectionRoute,AuthenticatedMembrosMeuProjetoMissaoIdRoute: AuthenticatedMembrosMeuProjetoMissaoIdRoute,AuthenticatedMembrosMeuProjetoProjetoIdRoute: AuthenticatedMembrosMeuProjetoProjetoIdRoute
}

const AuthenticatedMembrosRouteWithChildren = AuthenticatedMembrosRoute._addFileChildren(AuthenticatedMembrosRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedMembrosRoute: AuthenticatedMembrosRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const CheckoutRouteChildren = {
  CheckoutSucessoRoute: CheckoutSucessoRoute
}

const CheckoutRouteWithChildren = CheckoutRoute._addFileChildren(CheckoutRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,AvisoLegalRoute: AvisoLegalRoute,CadastroRoute: CadastroRoute,CheckoutRoute: CheckoutRouteWithChildren,NoAccessRoute: NoAccessRoute,PrivacidadeRoute: PrivacidadeRoute,ReembolsoRoute: ReembolsoRoute,ResetPasswordRoute: ResetPasswordRoute,TermosRoute: TermosRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)